export enum JournalStatusEnum {
    Default = 0,
    Awaiting = 1,
    Success = 2,
    CreationError = 3,
    ExportError = 4
}